import React, { useState, useEffect, useRef } from "react";

import styles from "./Filters.module.css";
import downArrow from "../../../img/down-arrow-grey.svg";
export default function SportFilter({ onChange, selected }) {
	const [open, setOpen] = useState(false);
	const toggle = () => {
		setOpen(!open);
	};
	return (
		<div className={styles.sportFilter}>
			<button type="button" onClick={() => toggle()}>
				Sport Types <img src={downArrow} />
			</button>
			{open ? (
				<div className={styles.sportTypesMenu}>
					<label className={styles.container}>
						<input
							data-testid="checkbox-1"
							type="checkbox"
							checked={selected.baseball}
							onChange={() =>
								onChange({
									...selected,
									baseball: !selected.baseball,
								})
							}
						/>
						<span className={styles.checkmark}></span>
						Baseball
					</label>
					<label className={styles.container}>
						<input
							data-testid="checkbox-2"
							type="checkbox"
							checked={selected.football}
							onChange={() =>
								onChange({ ...selected, football: !selected.football })
							}
						/>
						<span className={styles.checkmark}></span>
						Football
					</label>
					<label className={styles.container}>
						<input
							data-testid="checkbox-3"
							type="checkbox"
							checked={selected.soccer}
							onChange={() =>
								onChange({ ...selected, soccer: !selected.soccer })
							}
						/>
						<span className={styles.checkmark}></span>
						Soccer
					</label>
					<label className={styles.container}>
						<input
							data-testid="checkbox-4"
							type="checkbox"
							checked={selected.softball}
							onChange={() =>
								onChange({ ...selected, softball: !selected.softball })
							}
						/>
						<span className={styles.checkmark}></span>
						Softball
					</label>
					<label className={styles.container}>
						<input
							data-testid="checkbox-5"
							type="checkbox"
							checked={selected.basketball}
							onChange={() =>
								onChange({ ...selected, basketball: !selected.basketball })
							}
						/>
						<span className={styles.checkmark}></span>
						Basketball
					</label>
				</div>
			) : null}
		</div>
	);
}
